module.exports = __webpack_public_path__ + "img/zhuli-title.261969a9.png";